import { string } from 'yup';
import type { TripType } from '@/types';

export function getTripTypeSchema() {
  return string()
    .oneOf<TripType | ''>(
      ['oneWay', 'roundTrip', 'multiDestination'],
      'generic.pleaseSelectAnOption',
    )
    .defined()
    .default('')
    .required('generic.pleaseSelectAnOption');
}
